import { NavLink, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faWallet } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserDetails } from "../../redux/features/auth/authSlice";
import { getUser, signOutSubmit } from "../../redux/features/auth/authService";
import DefaultImage from '../../assets/images/icons/blank_profile_pic.png';
import LogoutIcon from '../../assets/images/icons/logout.png';
import ProfileIcon from '../../assets/images/icons/profile.png';
import TicketsIcon from '../../assets/images/icons/tickets.png';
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "../LanguageSwitcher";
import { getAllCartItemsCount } from "../../redux/features/cart/cartServices";
import { showToast } from "../ToastMsg";
import { getWalletByUser } from "../../redux/features/wallet/walletServices";

const pages = [
    { name: "Home", path: "/" },
    { name: "Results", path: "/results" },
    { name: "Winners", path: "/winners" },
    { name: "About Us", path: "/about" },
    { name: "Contact", path: "/contact" }
];

const Navbar = ({ toggleSidebar }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const { hasCheckedAuth, details } = useSelector(selectUserDetails);
    const { itemCount, shouldRefreshCount } = useSelector((state) => state.cart);
    const { wallet, shouldRefreshWallet } = useSelector((state) => state.wallet);

    const [isOpen, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        dispatch(getUser());
        dispatch(getAllCartItemsCount());
        dispatch(getWalletByUser());
    }, [dispatch]);

    useEffect(() => {
        if (shouldRefreshCount) {
            dispatch(getAllCartItemsCount());
        }
    }, [shouldRefreshCount, dispatch]);

     useEffect(() => {
        if (shouldRefreshWallet) {
            dispatch(getWalletByUser());
        }
    }, [shouldRefreshWallet, dispatch]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleLogin = () => navigate('/auth/login');
    const toggleSignUp = () => navigate('/auth/register');

    const handleLogout = () => {
        dispatch(signOutSubmit())
            .unwrap()
            .then(() => {
                navigate('/');
            })
            .catch((error) => {
                showToast("error", error.message);
            });
    }

    const toggleMyTickets = () => {
        navigate('/my-tickets');
        setOpen(false);
    }

    const toggleMySubscriptions = () => {
        navigate('/subscriptions');
        setOpen(false);
    }

    const openCart = () => {
        navigate('/cart');
        setOpen(false);
    }

    const openProfile = () => {
        navigate('/my-profile');
        setOpen(false);
    }

    const openWallet = () => {
        navigate('/wallet');
        setOpen(false);
    }

    return (
        <>
            <div className={styles.navContainer}>
                <div className={styles.navBar}>
                    <div className={styles.logoSec}>
                        <NavLink to={'/'}>
                            <img src={LogoImg} alt="Logo" className={styles.logoImg} />
                        </NavLink>
                    </div>
                    <div className={styles.pagesList}>
                        <ul className={styles.navList}>
                            {pages.map(({ name, path }) => (
                                <li key={name}>
                                    <NavLink to={path} className={({ isActive }) =>
                                        `${isActive ? styles.active : ""} ${i18n.language === 'ta' ? styles.tamil : ""}`
                                    }>
                                        {t(name)}
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.rightSec}>
                        <LanguageSwitcher />
                        {hasCheckedAuth && (
                            details.id ? (
                                <>
                                    <div className={styles.walletSec} onClick={openWallet}>
                                        <div className={styles.wallet}>
                                            <span className={styles.walletAmount}>{wallet?.balance !== null? wallet.balance.toFixed(2) : 0}</span>
                                            <span className={styles.walletCurrency}>{wallet?.currency}</span>
                                        </div>
                                            <FontAwesomeIcon icon={faWallet}className={styles.walletIcon}/>
                                    </div>
                                     <div className={styles.cartSec} onClick={openCart}>
                                        {itemCount?.count > 0 &&
                                            <span className={styles.cartBadge}>{itemCount?.count}</span>
                                        }
                                    </div>
                                    <div
                                        className={styles.profileSec}
                                        ref={dropdownRef}
                                    >
                                        <img
                                            src={details?.image_url ? details?.image_url : DefaultImage}
                                            className={styles.imageSec}
                                            onClick={() => setOpen(!isOpen)}
                                            alt="profile"
                                        />
                                        {isOpen ? (
                                            <div className={styles.dropdownMenu}>
                                                <div className={styles.profileHeader}>
                                                    <img
                                                        src={details?.image_url ? details?.image_url : DefaultImage}
                                                        className={styles.dropImageSec}
                                                        alt="Profile"
                                                    />
                                                    <div className={styles.nameSec}>
                                                        <p className={styles.name}>{details?.username}</p>
                                                        <p className={styles.email}>
                                                            {details?.email?.length > 25
                                                                ? `${details.email.slice(0, 22)}...`
                                                                : details?.email}
                                                        </p>
                                                    </div>
                                                </div>
                                                <ul className={styles.profileMenu}>
                                                    <li onClick={openProfile} className={styles.dropdownItem}>
                                                        <img src={ProfileIcon} width={24} />
                                                        {t('Profile')}
                                                    </li>
                                                    <li onClick={toggleMyTickets} className={styles.dropdownItem}>
                                                        <img src={TicketsIcon} width={24} alt="My Tickets Icon" />
                                                        {t('Ticket')}
                                                    </li>
                                                    <li onClick={toggleMySubscriptions} className={styles.dropdownItem}>
                                                        <img src={TicketsIcon} width={24} alt="My Tickets Icon" />
                                                        {t('Subscription')}
                                                    </li>
                                                    <li onClick={handleLogout} className={styles.dropdownItem}>
                                                        <img src={LogoutIcon} width={24} />
                                                        {t('Logout')}
                                                    </li>
                                                </ul>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <button type="button" className={styles.loginBtn} onClick={toggleLogin}>{t('Login')}</button>
                                    <button type="button" className={styles.regBtn} onClick={toggleSignUp}>{t('Register')}</button>
                                </>
                            )
                        )}
                        <div className={styles.barIcon} onClick={toggleSidebar}>
                            <FontAwesomeIcon icon={faBars} size="lg" style={{ color: '#1D0C50' }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;